export const SIZE = 10;
export const TABS = {
  Endpoints: 0,
  MyRequests: 1,
  AllRequests: 2,
  Appointments: 3,
};
